const policySettingIdToI18Key = (settingId: string): string => settingId.split('.').join('_');

export default policySettingIdToI18Key;
